Vue.asyncComponent('bp-editor-form', {
    data() {
        return {
            minWidth: null,
            width: null,
        }
    },
    computed: {
        bundle() {
            return this.$route.params.bundle;
        },
        definition() {
            return this.$route.params.definition;
        },
        objectId() {
            return this.$route.params.objectId;
        },
        relationString() {
            return this.$route.params.relationString;
        }
    },
    methods: {
        goToEditor() {
            this.$router.push({
                name: 'blueprint', params: {
                    blueprintId: this.$route.params.blueprintId
                },
                query: this.$route.query
            });
        },
        close() {
            // go to the parent route
            this.$router.push({
                ...this.$route.matched[0],
                query: this.$route.query
            });
        },
        /**
         * Set the current minWidth
         * @param minWidth
         */
        setMinWidth(minWidth) {
            this.minWidth = minWidth;
        },
        /**
         * Update width
         *
         * Update the current width for this bundle and definition
         * @param width
         */
        updateWidth(width) {
            this.width = width;
            // We keep the current width in the local storage so when the user comes back tot this form we will use the same width
            localStorage.setItem(`${this.bundle}-${this.definition}-width`, this.width);
        }
    },
    created() {
        // Check if we have a width for this form and definition in storage
        const widthInStorage = localStorage.getItem(`${this.bundle}-${this.definition}-width`);

        if (widthInStorage) {
            this.width = widthInStorage;
        }
    }
}, 'blueprints/form/bp-editor-form.html');